import type { BrandIdentifier } from "../../../../aysa_api/entities/brands/v1/brand_identifier.types";
import { Reader, Writer } from "protobufjs/minimal";
import type { Long } from "protoc-gen-ts";

export const createBaseBrandIdentifier = (): BrandIdentifier => {
  return {};
};

export const decodeBrandIdentifier = (
  reader: Reader,
  length: number
): BrandIdentifier => {
  const end = reader.pos + length;
  const message = createBaseBrandIdentifier();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.identifier = {
          $case: "id",
          id: (reader.int64() as Long).toNumber(),
        };

        break;
      case 2:
        message.identifier = {
          $case: "slug",
          slug: reader.string(),
        };

        break;
      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeBrandIdentifier = (
  writer: Writer,
  message: BrandIdentifier
): Writer => {
  if (message.identifier !== undefined) {
    switch (message.identifier.$case) {
      case "id":
        writer.uint32(8).int64(message.identifier.id);

        break;
      case "slug":
        writer.uint32(18).string(message.identifier.slug);

        break;
    }
  }
  return writer;
};
